// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31AsE","right":"styles_right__1u-Ov"};